import styles from './search.module.scss';
import { useCourseTableHook } from '../../../requestUtils';
import WebkuaTable from '../../../webkua-table/webkua-table';
import { CreateHeaders, HeaderSizeEnum, currencyHeader, textHeader, dateHeader } from '@frontend-workspace/react-shared-lib';
import { IRegistrationPeriod } from '../../../_models/registration-period';
import { durationRenderer } from '../../helpers';
import SearchSkeleton from './search-skeleton';
import { endOfMonth, startOfMonth } from 'date-fns';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface SearchProps { }

export function Search(props: SearchProps) {
  const { t } = useTranslation();

  const { data: registrationPeriod, isLoading, dateRange, onDateChange } = useCourseTableHook<IRegistrationPeriod>(`course/registrations/periode`, {
    startDate: startOfMonth(new Date()), endDate: endOfMonth(new Date())
  });

  return (<>
    {isLoading ? <SearchSkeleton /> :
      <WebkuaTable
        data={registrationPeriod}
        dateRange={dateRange}
        onSetDateRange={onDateChange}
        headers={CreateHeaders([
          dateHeader("date", t('standard.date')),
          textHeader("courseName", t('standard.courseName'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("duration", t('standard.duration'), HeaderSizeEnum.EXTRA_LARGE, { renderer: durationRenderer }),
          textHeader("instructor", t('standard.instructor'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("place", t('standard.place'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("room", t('standard.trainingRoom'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("company", t('standard.company'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("participant", t('standard.courseParticipant'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("invoiceEmail", t('standard.email'), HeaderSizeEnum.EXTRA_LARGE),
          currencyHeader("price.value", t('standard.price'), HeaderSizeEnum.EXTRA_LARGE, {
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          })
        ])}
      />}
  </>);
}

export default Search;
